module.exports = __webpack_public_path__ + "img/p2-40.47f6340b.png";